import { Controller } from "@hotwired/stimulus"

// Submits the form the moment a control changes — for filter/selector forms
// where an Apply button would only add a second, redundant interaction model.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
